<template>
  <div :class="classes">
    <dx-button
      :class="buttonClass"
      :primary="primary"
      :secondary="secondary"
      :success="success"
      :warning="warning"
      :danger="danger"
      :info="info"
      :default="isDefault"
      :link="link"
      :loading="loading"
      :small="small"
      :large="large"
      :disabled="disabled"
      @click.native="openConfirm"
      >
      <slot></slot>
    </dx-button>
    <div class="dx-button-confirm__items">
      <p>{{ $t('areYouSure') }}</p>
      <dx-button danger small @click.native="onConfirm">
        {{ $t('yes') }}
      </dx-button>
      <dx-button default small @click.native="onCancel">
        {{ $t('no') }}
      </dx-button>
    </div>
  </div>
</template>

<script>
import 'vue-awesome/icons/times'
import DxButton from './DxButton.vue'
import DxUserAvatar from './DxUserAvatar.vue'

export default {
  name: 'dx-button-confirm',
  components: {
    DxButton,
    DxUserAvatar
  },
  props: {
    buttonClass: String,
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    warning: Boolean,
    danger: Boolean,
    info: Boolean,
    default: Boolean,
    link: Boolean,
    loading: Boolean,
    small: Boolean,
    large: Boolean,
    disabled: Boolean,
    left: Boolean,
    right: Boolean
  },
  data () {
    return {
      confirm: false
    }
  },
  methods: {
    openConfirm () {
      this.confirm = true
    },
    onCancel () {
      this.confirm = false
    },
    onConfirm () {
      this.confirm = false
      this.$emit('click')
    }
  },
  computed: {
    classes () {
      return {
        'dx-button-confirm': true,
        'dx-button-confirm--active': this.confirm,
        'dx-button-confirm--left': this.left,
        'dx-button-confirm--right': this.right
      }
    },
    isDefault () {
      return this.default
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DxButtonConfirm.vue